import { useEffect } from "react";

/**
 * Marks the page as a touch surface while `active`: the `[data-surface="kiosk"]` rule in
 * src/styles/tokens.css gives buttons and fields the 44px touch height at any width (DECISIONS.md D1).
 * The attribute is cleared when `active` turns false or the component unmounts.
 */
export function useTouchSurface(active: boolean): void {
  useEffect(() => {
    if (!active) return undefined;
    const root = document.documentElement;
    root.dataset.surface = "kiosk";
    return () => {
      delete root.dataset.surface;
    };
  }, [active]);
}
